'use strict';
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  
  var _CaretUpOutlined = _interopRequireDefault(require('./lib/icons/CaretUpOutlined'));
  
  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
  
  var _default = _CaretUpOutlined;
  exports.default = _default;
  module.exports = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@ant-design/icons/CaretUpOutlined.js
// module id = 1229
// module chunks = 0